export default "/_next/static/images/Tropical-9c43555f9f065f437325e1b70d364908.png";